import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { CompanyName } from '../config/Constants';
import useUserContext from '../config/UserContext';

const stylesheet = {
    footer: 'tw:mt-2 tw:fixed tw:bottom-0 tw:left-0 tw:right-0 tw:z-[1030]',
    nav: 'tw:bg-[#f8f9fa] tw:py-2',
    container: 'tw:w-full tw:px-3 tw:flex tw:flex-wrap tw:items-center tw:justify-between',
    navLeft: 'tw:flex tw:me-auto',
    navLink: 'tw:text-[rgba(0,0,0,0.65)] tw:no-underline tw:hover:text-[rgba(0,0,0,0.8)] tw:text-base tw:py-2 tw:px-2',
    copyright: 'tw:text-[rgba(0,0,0,0.65)] tw:text-base',
};

function Footer(/* props */) {
    const user = useUserContext();
    const { t } = useTranslation();
    const isOrgAdmin = user?.attributes?.orgAdmin || false;
    const canGrant = user?.attributes?.canGrant || false;

    return (
        <footer className={stylesheet.footer}>
            <nav className={stylesheet.nav}>
                <div className={stylesheet.container}>
                    <div className={stylesheet.navLeft}>
                        <a className={stylesheet.navLink} href="/about">
                            {t('nav.about')}
                        </a>
                        <a className={stylesheet.navLink} href="/gettingstarted">
                            {t('nav.gettingStarted')}
                        </a>
                        <a className={stylesheet.navLink} href="/howto">
                            {t('nav.howTo')}
                        </a>
                        {(isOrgAdmin || canGrant) && (
                            <a className={stylesheet.navLink} href="/api">
                                {t('nav.api')}
                            </a>
                        )}
                    </div>
                    <div>
                        <span className={stylesheet.copyright}>
                            {t('nav.copyright')}
                            { ' ' }
                            {CompanyName}
                        </span>
                    </div>
                </div>
            </nav>
        </footer>
    );
}

export default memo(Footer);
